/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuthenticatorAssuranceLevel } from './authenticatorAssuranceLevel';


/**
 * A singular authenticator used during authentication / login.
 */
export interface SessionAuthenticationMethod { 
    aal?: AuthenticatorAssuranceLevel;
    /**
     * When the authentication challenge was completed.
     */
    completed_at?: string;
    method?: SessionAuthenticationMethod.MethodEnum;
    /**
     * The Organization id used for authentication
     */
    organization?: string;
    /**
     * OIDC or SAML provider id used for authentication
     */
    provider?: string;
}
export namespace SessionAuthenticationMethod {
    export type MethodEnum = 'link_recovery' | 'code_recovery' | 'password' | 'code' | 'totp' | 'oidc' | 'webauthn' | 'lookup_secret' | 'v0.6_legacy_session';
    export const MethodEnum = {
        LinkRecovery: 'link_recovery' as MethodEnum,
        CodeRecovery: 'code_recovery' as MethodEnum,
        Password: 'password' as MethodEnum,
        Code: 'code' as MethodEnum,
        Totp: 'totp' as MethodEnum,
        Oidc: 'oidc' as MethodEnum,
        Webauthn: 'webauthn' as MethodEnum,
        LookupSecret: 'lookup_secret' as MethodEnum,
        V06LegacySession: 'v0.6_legacy_session' as MethodEnum
    };
}


